import { createSlice } from '@reduxjs/toolkit';
import { logoutRequest } from '../../../services/authRequest';
// import {logoutRequest} from "../../services/authRequest";

const userData = () => {
  const data = localStorage.getItem('user');
  try {
    return data ? JSON.parse(data) : null;
  } catch (e) {
    return null;
  }
};
const userSlice = createSlice({
  name: 'user',
  initialState: {
    isLoggedIn: !!userData(),
    info: userData(),
    isLoad: false,
    code: [],
  },
  reducers: {
    setLogin: (state, action) => {
      localStorage.setItem('user', JSON.stringify(action.payload));
      state.isLoggedIn = true;
      state.info = action.payload;
    },
    setAuthUpdate: (state, action) => {
      const newData = { ...action.payload, token: state.info.token };
      localStorage.setItem('user', JSON.stringify(newData));
      state.info = newData;
    },
    setLogout: (state) => {
      logoutRequest()
        .then(() => {
          localStorage.removeItem('user');
        })
        .catch((error) => {
          localStorage.removeItem('user');
        });
      sessionStorage.clear();
      state.isLoggedIn = false;
      state.info = null;
      state.code = [];
    },
    setCode: (state, action) => {
      state.code = action.payload;
    },
    setAppLoading: (state, action) => {
      state.isLoad = action.payload;
    },
  },
});

const { actions, reducer } = userSlice;
export const { setLogin, setLogout, setCode, setAppLoading, setAuthUpdate } = actions;
export default reducer;
